import OutletBookingContext from "pages/OutletPage/outletContext";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "store";
import { selectOrganization, selectSessionId } from "store/selectors";
import cartApi from "store/slices/cart/cartApi";
import { clearCartArticles } from "store/slices/cart/cartSlice";
import { trackEvent } from "tracking";

import HomeServiceConfirmationModal from "./HomeServiceConfirmationModal";

type HomeServiceResetAppointmentModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const HomeServiceResetAppointmentModal = ({
  open,
  onClose,
  onConfirm,
}: HomeServiceResetAppointmentModalProps) => {
  const { t } = useTranslation("outletPage");

  const organization = useSelector(selectOrganization);

  const { setSelectedPurchasable, setSelectedPurchasablePackage } =
    useContext(OutletBookingContext);

  const dispatch = useDispatch();

  const sessionId = useSelector(selectSessionId);

  const handleProceed = async () => {
    dispatch(clearCartArticles());

    if (sessionId) await cartApi.clearSessionDrafts(sessionId);

    setSelectedPurchasable(null);
    setSelectedPurchasablePackage(null);

    if (organization?.id && organization?.name) {
      trackEvent("Lost Cart", { id: organization.id, name: organization.name }, {});

      trackEvent(
        "Cart Initiated",
        { id: organization.id, name: organization.name },
        { isResourceSelected: false }
      );
    }

    onConfirm();
  };

  return (
    <HomeServiceConfirmationModal
      open={open}
      onClose={onClose}
      onConfirm={handleProceed}
      description={t("changingTimeSlotWarning")}
    />
  );
};
export default HomeServiceResetAppointmentModal;
